// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WaveWrapper_wrapper__X4Lqn","wave":"WaveWrapper_wave__welAL"};